import { Link } from "react-router-dom";
import { DOMAN, KONTAKT, KONTAKT_LANK, PRODUKT } from "../../lib/config";
import { Marke } from "../Marke";

export function Sidfot() {
  return (
    <footer className="fot">
      <div className="wrap">
        <Marke />
        <nav className="links" aria-label="Sidfot">
          <a href="#sa-fungerar-det">Så fungerar det</a>
          <a href="#piloten">Piloten</a>
          <a href="#inlarning">Inlärning</a>
          <a href="#regelchatt">Regelchatt</a>
          <a href="#sakerhet">Säkerhet</a>
          {KONTAKT ? <a href={KONTAKT_LANK}>Kontakt</a> : null}
          <Link to="/logga-in">Logga in</Link>
        </nav>
        <div className="bottom">
          <span>© {new Date().getFullYear()} {PRODUKT}</span>
          <span>Molntjänst · data lagras inom EU · <span className="num">www.{DOMAN}</span></span>
        </div>
      </div>
    </footer>
  );
}
